import script from "./IntroCard.vue?vue&type=script&setup=true&lang=js"
export * from "./IntroCard.vue?vue&type=script&setup=true&lang=js"

import "./IntroCard.vue?vue&type=style&index=0&id=20fc26c8&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-20fc26c8"]])

export default __exports__